module.exports = __webpack_public_path__ + "img/creative@2x.3e97d6e.webp";